const orderTimeCount = (currentTime, fixedTime, isCountdown) => {
  if (isCountdown) {
    const msUntilEta = new Date(fixedTime) - new Date(currentTime);
    const secsUntilEta = Math.floor(msUntilEta / 1000);

    return secsUntilEta;
  }

  const ageMs = new Date(currentTime) - Date.parse(fixedTime);
  const ageSecs = Math.max(0, Math.floor(ageMs / 1000));

  return ageSecs;
};

export default orderTimeCount;



// WEBPACK FOOTER //
// ../utils/functions/order-time-count.js